function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M512 213.333333C299.989333 213.333333 85.333333 279.296 85.333333 405.333333S299.989333 597.333333 512 597.333333c212.053333 0 426.666667-65.962667 426.666667-192S724.053333 213.333333 512 213.333333z m-213.333333 424.021334v128c52.778667 12.757333 111.146667 20.565333 170.666666 23.082666v-128a903.082667 903.082667 0 0 1-170.666666-23.082666z m256 23.04v128a895.744 895.744 0 0 0 170.666666-23.082667v-128a895.744 895.744 0 0 1-170.666666 23.082667z m256-50.389334v128c76.842667-32.213333 128-79.232 128-140.672v-128c0 61.44-51.157333 108.458667-128 140.672z m-597.333334 128v-128C136.533333 577.792 85.333333 530.730667 85.333333 469.333333v128c0 61.397333 51.2 108.458667 128 140.672z",
  "p-id": 4878,
  fill: "#dbdbdb"
});

var SvgPlatIcon = function SvgPlatIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1625666889465,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 4877,
    width: 75,
    height: 75,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlatIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PlatIcon.669ebfd1.svg";
export { ForwardRef as ReactComponent };